import { CURRENCY, PRODUCT_STATUS } from "../Product/IProduct";

export enum OfferStatusEnum {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  SOLD = "SOLD",
  CANCELED = "CANCELED",

  NOT_AVAILABLE = "NOT_AVAILABLE",
  AVAILABLE = "AVAILABLE",
}

export enum MessageTypeEnum {
  TEXT = "TEXT",
  LOCATION = "LOCATION",
  OFFER = "OFFER",
}

export enum OffersTabEnum {
  SELLING = "SELLING",
  BUYING = "BUYING",
  DEALING = "DEALING",
}

export interface IChatUserDto {
  id: number;
  name: string;
  phone: string;
  avatar: string;
  avatarPath: string;
  isSeller: boolean;
  productId: number;
  productTitle: string;
  productImage: string;
  imagePath: string;
  productPrice: number;
  currencyType: CURRENCY;
  offerId: string;
}

export interface IMessageDto {
  id: number;
  chatId: number;
  text: string;
  messageType: string;
  sender: number;
  receiver: number;
  createdAt: string;
}

export interface IMessageOfferParsedText {
  createdBy: number;
  currencyType: CURRENCY;
  price: number;
  status: OfferStatusEnum;
}

export interface IOfferedProductDto {
  createdBy: string;
  createdAt: string;
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  imagePath: string;
  price: number;
  currencyType: string;
}

export interface IOfferedSellProductDto {
  createdBy: string;
  createdAt: string;
  totalOffersCount: number;
  unreadOffersCount: number;
  updatedAt: string;
  isViewed: boolean;
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  imagePath: string;
  price: number;
  currencyType: CURRENCY;
}

export interface IOfferedBuyProductDto {
  createdBy: string;
  createdAt: string;
  chatId: number;
  offerPrice: number;
  offerId: number;
  offerCurrencyType: CURRENCY;
  offerStatus: OfferStatusEnum;
  offerUpdatedAt: string;
  isViewed: boolean;
  newMessageCount: number; // CHECK
  messageText: string;
  messageType: MessageTypeEnum;
  messageTime: string;
  sellerAvatar: string;
  sellerAvatarPath: string;
  sellerName: string;
  sellerPhone: string;
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  imagePath: string;
  price: number;
  currencyType: CURRENCY;
}

// TODO check deal item
export interface IOfferedDealProductDto {
  createdBy: string;
  createdAt: string;
  totalOffersCount: number;
  unreadOffersCount: number;
  updatedAt: string;
  isViewed: boolean;
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  imagePath: string;
  price: number;
  offerPrice: number;
  currencyType: CURRENCY;

  offerId: number; // TODO check deal item
}

export interface IProfileChatDto {
  id: number;
  firstName: string;
  lastName: string;
  phone: string;
  productId: number;
  productName: string;
  productImage: string;
  imagePath: string;
  productPrice: string | null;
  productCurrencyType: CURRENCY;
  avatarId: string | null;
  avatarPath: string | null;
  offerId: number;
  offerPrice: string | null;
  currencyType: CURRENCY;
  offerStatus: PRODUCT_STATUS;
}

export interface ISellProductOffers {
  product: IOfferedProductDto;
  chats: IChatListDto[];
}

export interface IChatListDto {
  id: number;
  firstname: string;
  lastname: string;
  middleName: string;
  phone: string;
  offerId: number;
  avatarId: string;
  avatarPath: string;
  offerPrice: number;
  currencyType: CURRENCY;
  messageText: string;
  messageType: MessageTypeEnum;
  messageTime: string;
  newMessageCount: number;
  isViewed: boolean;
}

export interface IOfferDto {
  id: number;
  price: number;
  currencyType: CURRENCY;
  status: OfferStatusEnum;
  createdAt: string;
  offeredBy: number;
  updatedBy: number;
  sellerPhone: string;
  buyerPhone: string;
  productStatus: PRODUCT_STATUS;
}

export interface ITabUnreadMessageCountDto {
  buying: number;
  selling: number;
  dealing: number;
}

export interface IAcceptedOfferDto {
  id: number;
  productId: number;
  productName: string;
  productDescription: string;
  imageUrl: string;
  imagePath: string;
  imageMode: string;
}

export interface IMakeOfferDto {
  id: number | null;
  price: number;
  quantity: number;
  currencyType: string;
}

export interface IPageableParams {
  page: number | string;
  size: number | string;
  sort: string[];
}

// ---------------- OFFERS CONTROLLER ----------
export interface IFetchOffersParams extends IPageableParams {
  tab: OffersTabEnum;
}

export interface IChangeOfferParams {
  id: number;
  status: OfferStatusEnum;
}

// ---------------- CHAT CONTROLLER ----------
export interface ICreateChatBody {
  userId: number;
  productId: number;
}

export interface ICreateChatResponse {
  id: number;
  offerId: number;
  leftUserId: number;
  rightUserId: number;
}

export interface IUpdateChatParams {
  chatId: number;
  offerId: number;
}

export interface IFetchChatParams extends IPageableParams {
  productId: number;
  tab: OffersTabEnum;
}

export interface IFetchArchivedChatParams {
  type: Exclude<OffersTabEnum, OffersTabEnum.DEALING>;
}

// ---------------- MESSAGE CONTROLLER ----------
export interface IPostMessageBody {
  chatId: number;
  text: string;
  messageType: string;
}
export interface IUpdateMessageBody {
  id: number;
  text: string;
  messageType: string;
}

export interface IFetchMessageParams {
  lastId: number;
  size: number;
  chatId: number;
}
